export default __webpack_public_path__ + "static/media/header_example_with_authorization_and_tenant_insomnia.a9da6c10.png";